import './textarea.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';

const isActive = props => props.meta.active || props.input.value !== '';
const hasValue = props => !props.meta.active &&  props.input.value !== '';

const propTypes = {
	input: PropTypes.object,
	placeholder: PropTypes.string,
	meta: PropTypes.object,
	disabled: PropTypes.bool,
	autoFocus: PropTypes.bool,
	showLabel: PropTypes.bool,
	initialHeight: PropTypes.number
};

const defaultProps = {
	autoFocus: false,
	showLabel: true
};

class Text extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.toggleStyles(this.props);

		if (this.props.autoFocus) {
			this.focus();
		}

	}

	componentWillReceiveProps(nextProps) {
		this.toggleStyles(nextProps);
	}

	setStyles() {
		const { textarea, label } = this.refs;
		const labelW = label.offsetWidth;
		const textareaH = textarea.offsetHeight;

		label.style.cssText = `
			position:absolute;
			right:0;
			left:inherit;
			width: ${labelW}px
		`;

		textarea.style.cssText = `
			padding-right: ${labelW}px;
			height: ${this.props.initialHeight || textareaH}px;
		`;
		if (this.props.minHeight) {
			textarea.style.cssText += `min-height: ${this.props.minHeight}px;`;
		}
	}

	resetStyles() {
		const { textarea, label } = this.refs;
		const textareaH = textarea.offsetHeight;

		label.style.cssText = '';
		textarea.style.cssText = `height: ${this.props.initialHeight || textareaH}px;`;

		if (this.props.minHeight) {
			textarea.style.cssText += `min-height: ${this.props.minHeight}px;`;
		}
	}

	toggleStyles(props) {
		isActive(props) ? this.setStyles() : this.resetStyles();
	}

	focus() {
		const { textarea } = this.refs;
		if (typeof textarea.selectionStart === 'number') {
			textarea.selectionStart = textarea.selectionEnd = textarea.value.length;
		} else if (typeof textarea.createTextRange !== 'undefined') {
			textarea.focus();
			const range = textarea.createTextRange();
			range.collapse(false);
			range.select();
		}
	}

	render() {
		const {touched, error} = this.props.meta;
		const { className } = this.props;

		return (
			<div
				onClick={ () => this.refs['textarea'].focus() }
				className={cn({
					'form-element-wrap-improve': true,
					[className]: !!className
				})}>
				<div className={cn(
					'form-element-field',
					this.props.showLabel && 'form-element-field--show-label'
				)}>
					<div className="form-element-field__label">
						{this.props.placeholder}
					</div>
					<div className={cn({
						'form-element-text': true,
						'is-active': isActive(this.props),
						'has-value': hasValue(this.props),
						'is-disabled': this.props.disabled
					})}>
						<div className="form-element-text__control">
							<textarea
								ref="textarea"
								className="control"
								autoFocus={this.props.autoFocus}
								disabled={this.props.disabled}
								{...this.props.input} />
						</div>
						<div className="form-element-text__placeholder" ref="label">
							{this.props.placeholder}
						</div>
					</div>

					{touched && error && (
						<div className="form-element-error"><span>{ error }</span></div>
					)}
				</div>
			</div>
		);
	}
}

Text.defaultProps = defaultProps;
Text.propTypes = propTypes;

export default Text;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/form-elements/textarea.js